import { useState } from "react";
import { X } from "lucide-react";

const DTC_RE = /^[PBCU][0-9A-F]{4}$/;

export default function DtcInput({ codes, setCodes }) {
  const [val, setVal] = useState("");
  const add = () => {
    const parts = val.toUpperCase().split(/[\s,;]+/).filter(Boolean);
    if (parts.length) setCodes([...new Set([...codes, ...parts])]);
    setVal("");
  };
  return (
    <div>
      <div className="flex gap-2">
        <input
          className="field mono uppercase"
          placeholder="Es. P0301, P0420"
          value={val}
          data-testid="dtc-input"
          onChange={(e) => setVal(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === ",") {
              e.preventDefault();
              add();
            }
          }}
        />
        <button type="button" onClick={add} className="btn-ghost px-4 text-sm" data-testid="dtc-add-button">
          Aggiungi
        </button>
      </div>
      {codes.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-3" data-testid="dtc-list">
          {codes.map((c) => (
            <span key={c} className={`tag flex items-center gap-1.5 ${DTC_RE.test(c) ? "text-[#FF4D4D] !border-red-500/40" : "text-amber-300"}`}
              data-testid={`dtc-tag-${c}`}>
              {c}
              <button type="button" onClick={() => setCodes(codes.filter((x) => x !== c))} data-testid={`dtc-remove-${c}`}>
                <X size={12} />
              </button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
